import { styled } from "styled-components";

const Button = styled.button`
    padding: 8px 8px;
    border: solid 1px var(--d8s-border);
    font-size: 18px;
    min-height: 20px;
    color: var(--d8s-primary);
    background-color: var(--d8s-bgPrimary);
    cursor: pointer;
    min-width: 30px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;

    &:hover {
		    border-color: var(--d8s-borderHover);
    }
`;

export default Button;
